import { type Route } from "../core";
import { type ProgramPage } from "./ProgramPage";

/**
 * Personal data policy route.
 */
export default {
  path: "/personal-data-policy",
  component: () =>
    import(/* webpackChunkName: "secondary" */ "./PersonalDataPolicy"),
  response: () => ({
    title: "Политика в сфере обработки персональных данных",
    description:
      "Политика в сфере обработки персональных данных интернет-магазина MadNuts.ru",
    keywords:
      "политика, обработка персональных данных, юридическая информация, орехи, сухофрукты, MadNuts.ru",
    // Info: ogTitle equals title
    ogDescription:
      "Политика в сфере обработки персональных данных интернет-магазина MadNuts.ru",
  }),
} as Route<ProgramPage>;
